import * as React from "react";

/** Tailwind's `md`. Below it the sidebar is a sheet, above it a column. */
const MOBILE_BREAKPOINT = 768;

/**
 * Whether the viewport is narrower than `md`.
 *
 * Read during the first render rather than in an effect. shadcn's version
 * starts `undefined` and fills in afterwards, which on a phone paints the
 * desktop column for one frame before replacing it with the sheet — and the
 * sheet, being a dialog, would then mount closed while something had already
 * asked it to open.
 */
export function useIsMobile(): boolean {
  const [isMobile, setIsMobile] = React.useState(
    () => window.innerWidth < MOBILE_BREAKPOINT,
  );

  React.useEffect(() => {
    const query = window.matchMedia(
      `(max-width: ${String(MOBILE_BREAKPOINT - 1)}px)`,
    );
    const onChange = () => {
      setIsMobile(query.matches);
    };

    onChange();
    query.addEventListener("change", onChange);
    return () => {
      query.removeEventListener("change", onChange);
    };
  }, []);

  return isMobile;
}
